import axios from 'util/Api'
import { useQuery } from '@tanstack/react-query';
import useDebounce from '../../useDebounce';
import {isUndefined} from 'lodash'

const GetUserSearchHistory = async (props) => {

	const Source = props.queryKey[1] !== undefined ? props.queryKey[1] : 0;
	const Keyword = props.queryKey[2] !== undefined ? props.queryKey[2] : '';

	let url = `/users/searchHistory?Source=${Source}&Keyword=${Keyword}`;

  const jwt =  JSON.parse(localStorage.token);

	const results = await axios
		.get(url, {headers: { 'Authorization':`Bearer ${jwt}`}})
		.then((response) => response.data);
	return results;
};


export const useGetUserSearchHistory = (Source, Keyword) => {

	const debouncedKeyword = useDebounce(Keyword, 500);

	const query = useQuery({
		queryKey: ['getUserSearchHistory', Source, debouncedKeyword],
		// queryFn: GetUserSearchHistory,
		refetchOnWindowFocus: false,
		enabled: !isUndefined(Source),
		queryFn: GetUserSearchHistory,
		retry: (failureCount, error) => {
			// Retry only if the failure count is less than or equal to 3 and the error is due to a 500 status code
			return (
				error.response?.status !== 401 &&
				error.response?.status !== 404 &&
				error.response?.status !== 403
			);
		},
	});
	return query;
};